export default __webpack_public_path__ + "static/study-banner376-5aceca00bc806ec6879e274e7a56827b.jpg";